export abstract class Icons {
  static Logo: string = '/meteorlogo_64.png';
  static Options: string = '/options_icon.png';
  static Roleplays: string = '/roleplays_icon.png';
  static Signature: string = '/aurie_signature.png';
  static TextInput: string = '/text_input_icon.png';
  static Updates: string = '/updates_icon.png';
}
